<template>
    <div class="wrapper">
        <div v-if="authenticated && !showLogo && !isFakeOverlay" :class="[typeClass, ...modifierClasses]" class="appHeader">
            <div class="mainHeader-inner">
                <div class="breadcrumb">
                    <div class="crumb main">Vlaanderen</div>
                    <div class="separator"></div>
                    <div class="crumb">Mijnmooiestraat.be</div>
                </div>
                <div class="top-navbar">
                    <div class="mainHeader-floater mainHeader-floater--left">
                        <Logo :modifiers="['mooieStraat', 'landscape', 'whiteBg', 'wide']" href="/home" class="mainHeader-siteNameLink" title="Mijn Mooie Straat"> Mijn Mooie Straat </Logo>
                    </div>
                    <div class="mainHeader-floater mainHeader-floater--right top-navbar-actions">
                        <!-- <div class="top-navbar-item help-center-item">Helpcenter</div> -->
                        <div class="top-navbar-item user-item">
                            <span class="dropdown-wrapper">
                                <AdvancedSelect :options="userProfileActions" :disableOuterScroll="isMobile" :showLabel="false" :customHeader="true" :alignRight="true" :bottomSpace="true" :fluidOnMobile="true" :largeOptions="true">
                                    <template v-slot:customHeader="slotProps">
                                        <div class="user-item">
                                            <img class="user-avatar" src="/images/icons/avatar-placeholder.svg" />
                                            <span class="user-name">{{ loggedUser.full_name }}</span>
                                            <span class="icon icon--arrowDown"></span>
                                        </div>
                                        <div class="hamburger-item">
                                            <span :class="['icon--' + icon.color, slotProps.isOpen ? 'icon--cross' : 'icon--hamburger']" class="icon" />
                                        </div>
                                    </template>

                                    <template v-slot:option="slotProps">
                                        <slot :option="slotProps.option" name="selectOption">
                                            <div class="link-item">
                                                <img class="link-item-icon" :src="slotProps.option.image" />
                                                <span>
                                                    {{ slotProps.option.isDynamic ? slotProps.option.title() : slotProps.option.title }}
                                                </span>
                                            </div>
                                            <span v-if="slotProps.option.icon" class="icon" :class="['icon--' + (slotProps.option.color || icon.color), 'icon--' + slotProps.option.icon, slotProps.option.class]" />
                                        </slot>
                                    </template>

                                    <template v-if="isMobile" #bottomNote>
                                        <div class="bottom-note">
                                            <router-link to="https://mijnmooiestraat.be/algemene-voorwaarden.php">Disclaimer</router-link>
                                            &copy; Mijn Mooie Straat {{ new Date().getFullYear() }}
                                        </div>
                                    </template>
                                </AdvancedSelect>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="[typeClass, ...modifierClasses, { 'mainHeader--overlay': isFakeOverlay }]" class="mainHeader">
            <div class="mainHeader-inner">
                <div v-if="!showLogo" class="page-navbar">
                    <div class="mainHeader-floater mainHeader-floater--left">
                        <h1 class="mainHeader-pageTitle">
                            <a v-if="showHamburger" href="#" class="mainHeader-hamburger" @click="onBackClick">
                                <span class="icon-wrapper">
                                    <span :class="['icon--' + icon.color, 'icon--' + icon.type]" class="icon" />
                                </span>
                            </a>
                            <span class="page-title">{{ cfg.title }}</span>
                        </h1>
                        <CloseFormOverlay ref="dirtyOverlay" :type="cfg.dirtyType" @confirm="onBack" />
                    </div>
                    <div v-if="!isFakeOverlay" class="mainHeader-floater mainHeader-floater--right">
                        <slot name="headerActions">
                            <span v-if="authenticated" class="mainHeader-action">
                                <span :key="avSelectKey" class="dropdown-wrapper">
                                    <AdvancedSelect :options="userDropdownActions" ref="userActions" :showLabel="false" :customHeader="true" :alignRight="true" :bottomSpace="true" :dropdownWidth="300" stickyOptions>
                                        <template v-slot:customHeader="slotProps">
                                            <span class="header-text">Opties</span>
                                            <span class="icon" :class="[slotProps.isOpen ? 'icon--arrowUp' : 'icon--arrowDown', showLogo ? 'icon--light' : '']" />
                                        </template>

                                        <template v-slot:option="slotProps">
                                            <slot :option="slotProps.option" name="selectOption">
                                                <span :key="avSelectKey">{{ slotProps.option.title }}</span>
                                                <span v-if="slotProps.option.icon" class="icon" :class="['icon--' + (slotProps.option.color || icon.color), 'icon--' + slotProps.option.icon]" />
                                            </slot>
                                        </template>
                                    </AdvancedSelect>
                                    <DeleteOverlay ref="deleteOverlay" :itemType="cfg.itemType || ''" :root="true" @apply="onDeleteClick">
                                        <template #body v-if="cfg.deleteOverlayBody">
                                            {{ cfg.deleteOverlayBody }}
                                        </template>
                                    </DeleteOverlay>
                                </span>
                            </span>
                        </slot>
                    </div>
                </div>
                <div v-if="isHome" class="mainHeader-inner">
                    <div class="mainHeader-floater mainHeader-floater--right">
                        <div class="top-navbar-item user-item user-item--white d-inline-block user-item-spacing">
                            <a class="user-item-faq" target="_blank" :href="faqLink">
                                <span>
                                    Help
                                    <span class="icon icon--help icon--light user-item-spacing"></span>
                                </span>
                            </a>
                        </div>
                        <div v-if="userAdminAccess" class="top-navbar-item top-navbar-item--community user-item user-item--white d-inline-block user-item-spacing">
                            <span class="dropdown-wrapper">
                                <AdvancedSelect :options="communityActions" :modifiers="['header-actions-dropdown']" :disableOuterScroll="isMobile" :showLabel="false" :customHeader="true" :alignRight="true" :bottomSpace="true" :fluidOnMobile="true" :largeOptions="true">
                                    <template v-if="isMobile" #topLogo>
                                        <div class="top-logo">
                                            <div>
                                                <Logo :modifiers="['mooieStraat', 'landscape', 'whiteBg', 'wide']" class="top-logo-image" title="Mijn Mooie Straat"> Mijn Mooie Straat </Logo>
                                            </div>
                                            <div class="top-logo-close">
                                                <a href="#" class="icon icon--shakespeare icon--cross"> Sluiten </a>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:customHeader>
                                        <div class="user-item">
                                            <span class="user-name">{{ community.title }}</span>
                                            <span class="icon icon--arrowDown icon--light" />
                                        </div>
                                    </template>

                                    <template v-slot:option="slotProps">
                                        <slot :option="slotProps.option" name="selectOption">
                                            <div class="link-item">
                                                <img class="link-item-icon" :src="slotProps.option.image" />
                                                <span>
                                                    {{ slotProps.option.isDynamic ? slotProps.option.title() : slotProps.option.title }}
                                                </span>
                                            </div>
                                            <span v-if="slotProps.option.icon" class="icon" :class="['icon--' + (slotProps.option.color || icon.color), 'icon--' + slotProps.option.icon, slotProps.option.class]" />
                                        </slot>
                                    </template>

                                    <template v-if="isMobile" #bottomNote>
                                        <div class="bottom-note">
                                            <router-link to="https://mijnmooiestraat.be/algemene-voorwaarden.php">Disclaimer</router-link>
                                            &copy; Mijn Mooie Straat {{ new Date().getFullYear() }}
                                        </div>
                                    </template>
                                </AdvancedSelect>
                            </span>
                            <!-- <router-link :to="{name: 'Community'}" class="user-item-faq">
                <span>
                  {{ community.title }}
                </span>
			  </router-link> -->
                        </div>
                        <div class="top-navbar-item user-item user-item--white d-inline-block">
                            <span class="dropdown-wrapper">
                                <AdvancedSelect :options="userProfileActions" :modifiers="['header-actions-dropdown']" :disableOuterScroll="isMobile" :showLabel="false" :customHeader="true" :alignRight="true" :bottomSpace="true" :fluidOnMobile="true" :largeOptions="true">
                                    <template v-if="isMobile" #topLogo>
                                        <div class="top-logo">
                                            <div>
                                                <Logo :modifiers="['mooieStraat', 'landscape', 'whiteBg', 'wide']" class="top-logo-image" title="Mijn Mooie Straat"> Mijn Mooie Straat </Logo>
                                            </div>
                                            <div class="top-logo-close">
                                                <a href="#" class="icon icon--shakespeare icon--cross"> Sluiten </a>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:customHeader="slotProps">
                                        <div class="user-item">
                                            <span class="user-name">{{ loggedUser.full_name }}</span>
                                            <span class="icon icon--arrowDown icon--light" />
                                        </div>
                                    </template>

                                    <template v-slot:option="slotProps">
                                        <slot :option="slotProps.option" name="selectOption">
                                            <div class="link-item">
                                                <img class="link-item-icon" :src="slotProps.option.image" />
                                                <span>
                                                    {{ slotProps.option.isDynamic ? slotProps.option.title() : slotProps.option.title }}
                                                </span>
                                            </div>
                                            <span v-if="slotProps.option.icon" class="icon" :class="['icon--' + (slotProps.option.color || icon.color), 'icon--' + slotProps.option.icon, slotProps.option.class]" />
                                        </slot>
                                    </template>

                                    <template v-if="isMobile" #bottomNote>
                                        <div class="bottom-note">
                                            <router-link to="https://mijnmooiestraat.be/algemene-voorwaarden.php">Disclaimer</router-link>
                                            &copy; Mijn Mooie Straat {{ new Date().getFullYear() }}
                                        </div>
                                    </template>
                                </AdvancedSelect>
                            </span>
                        </div>
                    </div>
                </div>
                <h1 v-if="showLogo" class="mainHeader-siteName">
                    <Logo :modifiers="logoModifiers" href="/home" class="mainHeader-siteNameLink" title="Mijn Mooie Straat"> Mijn Mooie Straat </Logo>
                </h1>
            </div>
        </div>
        <GdprOverlay ref="gdprOverlay" @approveClose="onGdprClose" />
    </div>
</template>

<script src="./Header.js"></script>
